import { Toast as BootstrapToast } from 'react-bootstrap';
import { ReactComponent as CancelIcon } from '../../../assets/icons/cancel.svg';
import { mergeClassNames } from '../../style';

const AUTO_HIDE_AFTER_MS = 3000;

export type ToastProps = {
  isVisible: boolean;
  onClose: VoidFunction;
  title: string;
  icon?: JSX.Element;
  autoClose?: boolean;
  type?: 'error' | 'success';
};

export const Toast = ({ isVisible, title, onClose, icon, autoClose = false, type }: ToastProps): JSX.Element => {
  const toasterContainerClassName = mergeClassNames([
    { className: 'core-toast__container' },
    { className: 'core-toast__container--success', include: type === 'success' },
    { className: 'core-toast__container--error', include: type === 'error' },
  ]);

  return (
    <BootstrapToast
      className={toasterContainerClassName}
      onClose={onClose}
      show={isVisible}
      delay={AUTO_HIDE_AFTER_MS}
      autohide={autoClose}
    >
      <BootstrapToast.Header className="core-toast__header" closeButton={false}>
        {icon && <p className="core-toast__header-icon">{icon}</p>}
        <p className="core-toast__header-title">{title}</p>
        <button type="button" onClick={onClose} aria-label="Close toast" className="core-toast__header-close-button">
          <CancelIcon />
        </button>
      </BootstrapToast.Header>
    </BootstrapToast>
  );
};
